export default __webpack_public_path__ + "static/media/birm.ec10a3b8.jpg";